import React from "react";
import './MobilePopup.less';

type MobilePopupProps = {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
};

const MobilePopup = ({ isOpen, title, onClose, children }: MobilePopupProps) => {
  return (
    <div className={`mobilePopup ${isOpen ? 'popupOpen' : ''}`}>
      <div className="popupHeader">
        <button className="closeButton" onClick={onClose}>×</button>
        <h2 className="popupTitle">{title}</h2>
      </div>
      <div className="popupBody">
        {children}
      </div>
    </div>
  );
};

export default MobilePopup;